(function () {
  'use strict';

  angular
    .module('cadastros.macro')
    .config(config);

  function config($stateProvider) {
    $stateProvider.state('root.macro', {
      url: '/macro?vfiltro&tabIndex',
      views: {
        'content@': {
          templateUrl: 'cadastros/macro/macro.tpl.html',
          controller: 'MacroCtrl',
          controllerAs: 'MacroCtrl'
        }
      },
      data: {
        titulo: 'ce.cadastro.macro.title',
        hideTitulo: true,
        roles: [['MACRO_VISUALIZAR']]
      }
    });

    $stateProvider.state('root.macro.form', {
      url: '/form/:macroGroupUUID?',
      views: {
        'content@': {
          templateUrl: 'cadastros/macro/form-macro.tpl.html',
          controller: 'FormMacroCtrl',
          controllerAs: 'FormMacroCtrl'
        }
      },
      data: {
        titulo: 'ce.cadastro.macro.title',
        hideTitulo: true,
        roles: [['MACRO_EDITAR']]
      }
    });
  }
}());
